
import { EventLogDto } from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'
import { PaginatedDto } from './extendedType'
import { axios } from './api'

export type EventLogsFilters = PaginatedQueryBase & {
  entityId: string
}

class EventLogService extends BaseCrudService<
  EventLogDto,
  {},
  {},
  EventLogsFilters
> {
  constructor() {
    super('event-log', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }

  override getAll(filters: EventLogsFilters): Promise<PaginatedDto<EventLogDto>> {
    const { entityId, ...pagination } = filters
    if (!entityId) return Promise.resolve({ datas: [], totalCount: 0 })

    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('get', `${this.endpoint}/entity/${entityId}`, undefined, pagination as Record<string, unknown>)
      axios(configs, resolve, reject)
    })
  }
}

export const eventLogService = new EventLogService()
